import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import { EmptyState } from "@/shared/feedback/EmptyState";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallbackTitle?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

/**
 * Kap gabimet e route/feature dhe shfaq UI te kontrolluar.
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Gabim ne frontend:", error, info);
  }

  public render(): ReactNode {
    if (this.state.hasError) {
      return (
        <EmptyState
          title={this.props.fallbackTitle ?? "Moduli nuk u ngarkua"}
          description="Provo perseri ose kontakto administrimin nese problemi vazhdon."
          icon={<AlertTriangle className="h-7 w-7" aria-hidden="true" />}
        />
      );
    }

    return this.props.children;
  }
}
